import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Users.svg?component
var Users_exports = /* @__PURE__ */ __exportAll({
	default: () => Users_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M3.375 7.875a4.125 4.125 0 1 0 8.25 0 4.125 4.125 0 1 0-8.25 0M.75 20.25a6.75 6.75 0 0 1 13.5 0m.001-15.834a4.125 4.125 0 1 1-.006 6.914M15 13.667a6.757 6.757 0 0 1 8.25 6.583" }, null, -1)])]);
}
var Users_default = { render: render$1 };
//#endregion
export { Users_exports, Users_default as default, render$1 as render };

//# sourceMappingURL=Users.svg.virtual.js.map